export const SETTINGS_DRAWERS = {
  BUSINESS_HOURS: 'businessHoursDrawer',
  CONTENT_AUTOMATION: 'contentAutomationDrawer',
  CONTENT_RULE: 'contentRuleDrawer',
  INSTALLATION_GUIDE: 'installationGuideDrawer',
  PERFORMANCE_ALERT: 'performanceAlertDrawer',
};
